/** Chi e collegato, come lo mostra il menu utente: iniziali e ruoli. */

import type { Ruolo } from '@calcio/shared';
import type { Utente } from '../accesso/useSessione.js';
import type { SquadraStagione } from './contesto.js';

const ETICHETTA: Record<Ruolo, string> = {
  super_admin: 'Super Admin',
  admin_squadra: 'Admin Squadra',
  mister: 'Mister',
  dirigente: 'Dirigente',
};

export function iniziali({ nome, cognome }: Pick<Utente, 'nome' | 'cognome'>): string {
  return `${nome.trim().charAt(0)}${cognome.trim().charAt(0)}`.toUpperCase();
}

/**
 * I ruoli come si leggono: quelli di societa da soli, quelli di squadra con
 * la squadra-stagione, se e fra quelle che l'utente vede. Il Super Admin lo e
 * per il suo flag, non per un'assegnazione.
 */
export function ruoliDi(utente: Utente, squadre: SquadraStagione[] | null): string[] {
  const righe = utente.assegnazioni.map((a) => {
    const s = a.squadraStagioneId && squadre?.find((x) => x.id === a.squadraStagioneId);
    return s ? `${ETICHETTA[a.ruolo]} · ${s.squadra} ${s.stagione}` : ETICHETTA[a.ruolo];
  });
  return [...new Set(utente.superAdmin ? [ETICHETTA.super_admin, ...righe] : righe)];
}
